// Check if element is in view
export function isElementInView(elem) {
  const elemPosition = elem.getBoundingClientRect();
  return (elemPosition.top <= (window.innerHeight || document.documentElement.innerHeight));
}

/**
* Helper method to return scroll value on all browser
*/
export function getScrollTop() {
  let target;
  if (window.pageYOffset) return window.pageYOffset; // most browsers except IE before #9
  target = document.documentElement; // IE with doctype
  target = (target.clientHeight) ? target : document.body;
  return target.scrollTop;
}

// Debounce

// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.
export function debounce(func, wait, immediate) {
  let timeout;
  return function executedFunction() {
    const context = this;
    // eslint-disable-next-line prefer-rest-params
    const args = arguments;

    const later = () => {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };

    const callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}

export function setBannerHeight() {
  const banner = document.querySelector('.hero');
  const pageWithHeroForm = ['/lp/services/call-answering-service-ILP', '/lp/services/telephone-answering-service-ILP', '/lp/services/virtual-receptionist-ILP', '/lp/services/small-business-answering-ILP', '/lp/services/phone-answering-service-ILP', '/lp/services/after-hours-answering-service-ILP', '/services/call-center-solution'];

  if (banner && !pageWithHeroForm.includes(window.location.pathname)) {
    const bannerHeight = banner.clientHeight;
    document.querySelector('main').style.cssText = `top:${bannerHeight}px`;
  }
}

/* header fixed */

export function stickyHeader() {
  let bannerOffset = 0;
  if (document.querySelector('.banner-strip')) {
    bannerOffset = document.querySelector('.banner-strip').clientHeight;
  }
  const headerHeight = document.querySelector('header').clientHeight + bannerOffset;
  const mainOffset = document.querySelector('main').offsetTop;
  const pageWithHeroForm = ['/lp/services/call-answering-service-ILP', '/lp/services/telephone-answering-service-ILP', '/lp/services/virtual-receptionist-ILP', '/lp/services/small-business-answering-ILP', '/lp/services/phone-answering-service-ILP', '/lp/services/after-hours-answering-service-ILP', '/services/call-center-solution'];

  if (document.querySelector('.hero')) {
    if (pageWithHeroForm.includes(window.location.pathname)
    && (document.body.scrollTop > 10 || document.documentElement.scrollTop > 10)) {
      document.querySelector('header').classList.add('header--fixed');
    } else if (document.body.scrollTop > mainOffset - headerHeight
        || document.documentElement.scrollTop > mainOffset - headerHeight) {
      document.querySelector('header').classList.add('header--fixed');
    } else {
      document.querySelector('header').classList.remove('header--fixed');
    }
  } else if (document.body.scrollTop > 70 || document.documentElement.scrollTop > 70) {
    document.querySelector('header').classList.add('header--fixed');
  } else {
    document.querySelector('header').classList.remove('header--fixed');
  }
}

export const convertStringToURL = (urlString) => {
  try {
    return new URL(urlString);
  } catch (e) {
    console.error('invalid url: ', urlString);
  }
  return undefined;
};
